<h1 class="heading">{{ "LOADING_HEADING" | translate }}</h1>
<p class="paragraph">{{ "LOADING_PARAGRAPH" | translate }}</p>
<mat-progress-bar
  class="progress-bar"
  mode="determinate"
  [value]="this.progressValue"
></mat-progress-bar>
